import React from "react";
import styles from "./styles.module.css";

const BlankBlock = {
  label: "Space",
  fields: {},
  defaultProps: {},
  render: (props) => {

    const isEditing = props.puck?.isEditing;

    return (
      <div
        className={styles.Blank}
        style={{
          background: isEditing ? "#f0f0f0" : "transparent",
        }}
      />
    );
  },
};

export default BlankBlock;